import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BikeService } from '../../services/bike.service';
import { ServService } from '../../services/serv.service';
import { OrderService } from '../../services/order.service';

@Component({
  selector: 'my-oneBike',
  template: require('./oneBike.component.html'),
  styles: [require('./oneBike.component.scss')]
})

export class OneBikeComponent implements OnInit{

  constructor(public orderService:OrderService, private route:ActivatedRoute, private router:Router, private bikeService:BikeService, public servService:ServService) {

  }

  ngOnInit(): void {
    this.route.params.subscribe(params=> {
      if (params['id']) {
        this.bikeService.get(params['id']);
      } else {
        this.router.navigate(['/']);
      }
    });
  }

  refresh(id){
    this.bikeService.get(id);
  }

  openCustomer(privateId:string){
    this.router.navigate(['/customer', privateId]);
  }

  openService(service){
    this.servService.get(service.id);
  }

  openBill(bill){
    this.router.navigate(['invoice', bill.clientPrivateId, bill.id]);
  }

  openOrder(order){
    this.orderService.get(order.id);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/pages/oneBike/oneBike.component.ts